import { useCallback, useState } from 'react';

interface UseToggleCallbacks {
  set: (value: boolean) => void;
  toggle: () => void;
  enable: () => void;
  disable: () => void;
}

/**
 * useToggle
 *
 * Boolean state hook that provides callbacks for enabling, disabling, flipping
 * and setting state.
 */
export default function useToggle(initialValue = false): [boolean, UseToggleCallbacks] {
  const [value, setValue] = useState<boolean>(!!initialValue);
  const set = useCallback((newValue: boolean) => setValue(newValue), []);
  const toggle = useCallback(() => setValue(!value), [value]);
  const enable = useCallback(() => setValue(true), []);
  const disable = useCallback(() => setValue(false), []);
  return [value, { set, toggle, enable, disable }];
}
